import { render, staticRenderFns } from "./Sputum.vue?vue&type=template&id=94831aee&scoped=true"
import script from "./Sputum.vue?vue&type=script&lang=js"
export * from "./Sputum.vue?vue&type=script&lang=js"
import style0 from "./Sputum.vue?vue&type=style&index=0&id=94831aee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94831aee",
  null
  
)

export default component.exports